import {
    Badge,
    Box,
    Container,
    IconButton,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    InputAdornment,
    Card,
    CardContent,
    Stack,
    useTheme,
    useMediaQuery,
    Fade,
    alpha
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
    AddCircle,
    NotificationsActiveOutlined,
    WorkOutlineOutlined,
    AddBox,
    CropFree as CropFreeIcon,
    QrCode2 as QrCode2Icon,
    Search as SearchIcon,
    Rule as RuleIcon
} from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { qrScroll } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    getUnplannedMaintenanceActiveCounts,
    getPlannedMaintenanceActiveCounts,
    getNotifications,
    getBarcodeContent
} from "../../store/actions/TechnicianMainPageActions";
import { startUnPlannedMaintenance } from "../../store/actions/breakDownDetailActions";

export default function TechnicianMainPage(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    const [userInfo, setUserInfo] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [waitingApprovalCount, setWaitingApprovalCount] = useState(0);
    const [securityDialogOpen, setSecurityDialogOpen] = useState(false);
    const [qrOpen, setQrOpen] = useState(false);
    const [barcodeOpen, setBarcodeOpen] = useState(false);
    const [state, setState] = useState({ result: "No result" });
    const [activeOrderCreatedByUser, setActiveOrderCreatedByUser] = useState(0);
    const [activeOrder, setActiveOrder] = useState(0);
    const [activePlannedOrder, setActivePlannedOrder] = useState(0);
    const [activePlannedOrderCreatedByUser, setActivePlannedOrderCreatedByUser] = useState(0);

    const { t } = useTranslation("translation");
    const qrRef = useRef();
    let executedScroll = false;

    const { unplannedActiveCounts, plannedActiveCounts, notifications, barCodeInfo } = useSelector(
        ({ TechnicianMainPage }) => TechnicianMainPage
    );

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserInfo(oktaToken.idToken.claims.name);
        LoadData();

        const timer = setInterval(GetNotificationCount, 10000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (unplannedActiveCounts?.resultObject) {
            setActiveOrderCreatedByUser(unplannedActiveCounts.resultObject.activeTaskAssigneeToUser);
            setActiveOrder(unplannedActiveCounts.resultObject.activeOrder);
        }
    }, [unplannedActiveCounts]);

    useEffect(() => {
        if (plannedActiveCounts?.resultObject) {
            setActivePlannedOrderCreatedByUser(plannedActiveCounts.resultObject.activeTaskAssigneeToUser);
            setActivePlannedOrder(plannedActiveCounts.resultObject.activeOrder);
            setPageLoaded(true);
        }
    }, [plannedActiveCounts]);

    useEffect(() => {
        if (notifications?.resultObject) {
            setNotificationCount(notifications.resultObject.length);
        }
    }, [notifications]);

    useEffect(() => {
        if (barCodeInfo?.resultObject) {
            if (barCodeInfo.resultObject.length === 1) {
                BreakdownDetailPage(barCodeInfo.resultObject[0].id);
            } else {
                setSecurityDialogOpen(false);
                HandleTaskListOpen(barCodeInfo.resultObject);
            }
            barCodeInfo.resultObject = null;
        }
    }, [barCodeInfo]);

    const LoadData = () => {
        GetNotificationCount();
        dispatch(getUnplannedMaintenanceActiveCounts());
        dispatch(getPlannedMaintenanceActiveCounts());
    };

    const GetNotificationCount = () => {
        const username = GetUsername();
        dispatch(getNotifications(username));
    };

    const GetUsername = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        return oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
    };

    const ReportBreakdownPage = () => {
        props.history.push("/reportbreakdown?from=technician");
    };

    const OpenPlannedMaintenancePage = () => {
        props.history.push("create-planned-maintenance?from=technician");
    };

    const BreakdownListPage = () => {
        props.history.push("/lists");
    };

    const HandleScan = (data) => {
        executedScroll = qrScroll(qrRef, executedScroll);
        if (data) {
            setState({ ...state, result: data });
            setSecurityDialogOpen(true);
            setQrOpen(false);
        }
    };

    const BreakdownDetailPage = (id) => {
        dispatch(startUnPlannedMaintenance(id));
        props.history.push("breakdowndetail?id=" + id);
    };

    const HandleTaskListOpen = (barcodeArray) => {
        props.history.push("breakdownlist", { technicianMain: barcodeArray });
    };

    const OpenNotificationList = () => {
        props.history.push("/notificationlist");
    };

    const OpenApprovalPage = () => {
        props.history.push("/approval-page");
    };

    const HandleSecurityDialogClose = () => {
        setSecurityDialogOpen(false);
        dispatch(getBarcodeContent(state.result));
    };

    const HandleScanBarcode = (event) => {
        if (event.target.value) {
            setState({ ...state, result: event.target.value });
        }
    };

    const handleKeypress = (e) => {
        if (e.keyCode === 13) {
            setBarcodeOpen(false);
            setSecurityDialogOpen(true);
        }
    };

    const handleSubmit = () => {
        setBarcodeOpen(false);
        setSecurityDialogOpen(true);
    };

    const ActionButton = ({ icon: Icon, label, count, color, onClick, size = 'large' }) => (
        <Card 
            sx={{ 
                height: '100%',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                background: isMobile ? 
                    `linear-gradient(135deg, ${alpha(color || theme.palette.primary.main, 0.08)} 0%, ${alpha(color || theme.palette.primary.main, 0.03)} 100%)` : 
                    'background.paper',
                border: isMobile ? `1px solid ${alpha(color || theme.palette.primary.main, 0.1)}` : 'none',
                borderRadius: isMobile ? 3 : 1,
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                    background: isMobile ? 
                        `linear-gradient(135deg, ${alpha(color || theme.palette.primary.main, 0.12)} 0%, ${alpha(color || theme.palette.primary.main, 0.05)} 100%)` : 
                        'background.paper',
                },
                '&:active': {
                    transform: 'translateY(0)',
                }
            }}
            onClick={onClick}
        >
            <CardContent 
                sx={{ 
                    p: isMobile ? '12px 8px' : 2, 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    '&:last-child': {
                        paddingBottom: isMobile ? '12px' : 2
                    },
                    textAlign: 'center'
                }}
            >
                <Stack 
                    spacing={1} 
                    alignItems="center"
                    sx={{
                        transform: isMobile ? 'scale(0.9)' : 'none',
                        transition: 'transform 0.2s ease',
                        width: '100%'
                    }}
                >
                    <Badge 
                        badgeContent={count} 
                        color="error"
                        sx={{
                            '& .MuiBadge-badge': {
                                backgroundColor: theme.palette.error.main,
                                color: theme.palette.error.contrastText,
                                fontWeight: 600,
                                minWidth: 20,
                                height: 20,
                                fontSize: '0.75rem'
                            }
                        }}
                    >
                        <Icon 
                            sx={{ 
                                width: isMobile ? 32 : 48, 
                                height: isMobile ? 32 : 48,
                                color: color || theme.palette.primary.main,
                                transition: 'transform 0.2s ease',
                                '&:hover': {
                                    transform: 'scale(1.1)'
                                }
                            }} 
                        />
                    </Badge>
                    <Typography 
                        variant="body2" 
                        color="text.secondary"
                        sx={{ 
                            fontSize: isMobile ? '0.7rem' : '0.875rem',
                            fontWeight: 500,
                            lineHeight: 1.2,
                            maxWidth: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            width: '100%'
                        }}
                    >
                        {label}
                    </Typography>
                </Stack>
            </CardContent>
        </Card>
    );

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 3 }}>
            {pageLoaded && (
                <Container maxWidth="sm" sx={{ px: isMobile ? 1 : 3 }}>
                    <Stack spacing={isMobile ? 2 : 3}>
                        {/* Header */}
                        <Card 
                            sx={{ 
                                bgcolor: 'primary.main', 
                                color: 'primary.contrastText',
                                borderRadius: isMobile ? 3 : 1,
                                boxShadow: isMobile ? `0 4px 20px ${alpha(theme.palette.primary.main, 0.25)}` : theme.shadows[2]
                            }}
                        >
                            <CardContent sx={{ py: isMobile ? 1.5 : 2 }}>
                                <Typography 
                                    variant={isMobile ? "subtitle1" : "h6"} 
                                    align="center"
                                    sx={{ 
                                        fontWeight: isMobile ? 500 : 400,
                                        letterSpacing: isMobile ? 0.5 : 'inherit'
                                    }}
                                >
                                    {userInfo}
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Quick Actions */}
                        <Grid container spacing={isMobile ? 1.5 : 2}>
                            <Grid xs={4}>
                                <ActionButton
                                    icon={NotificationsActiveOutlined}
                                    label={t("Notifications")}
                                    count={notificationCount}
                                    color={theme.palette.warning.main}
                                    onClick={OpenNotificationList}
                                />
                            </Grid>
                            {JSON.parse(localStorage.getItem("authorizedToApprove")) && (
                                <Grid xs={4}>
                                    <ActionButton
                                        icon={RuleIcon}
                                        label={t("Approvals")}
                                        count={waitingApprovalCount}
                                        color={theme.palette.success.main}
                                        onClick={OpenApprovalPage}
                                    />
                                </Grid>
                            )}
                            <Grid xs={4}>
                                <ActionButton
                                    icon={WorkOutlineOutlined}
                                    label={t("Tasks")}
                                    count={`${activeOrderCreatedByUser}/${activeOrder}`}
                                    color={theme.palette.info.main}
                                    onClick={BreakdownListPage}
                                />
                            </Grid>
                        </Grid>

                        {/* Main Actions */}
                        <Card 
                            sx={{ 
                                borderRadius: isMobile ? 3 : 1,
                                background: isMobile ? 
                                    `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.paper, 1)} 100%)` : 
                                    'background.paper',
                                backdropFilter: 'blur(8px)',
                                boxShadow: isMobile ? `0 4px 20px ${alpha(theme.palette.primary.main, 0.15)}` : theme.shadows[1]
                            }}
                        >
                            <CardContent sx={{ p: isMobile ? '16px 8px' : 3 }}>
                                <Grid container spacing={1}>
                                    <Grid xs={4}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 1,
                                                px: 1
                                            }}
                                        >
                                            <Typography 
                                                variant="caption" 
                                                color="text.secondary" 
                                                align="center"
                                                sx={{ 
                                                    fontWeight: 500,
                                                    opacity: 0.9,
                                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                                    lineHeight: 1.2,
                                                    minHeight: '2.4em',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {t("OpenBreakdownRequest")}
                                            </Typography>
                                            <IconButton 
                                                onClick={ReportBreakdownPage}
                                                sx={{ 
                                                    bgcolor: alpha(theme.palette.secondary.main, 0.08),
                                                    p: isMobile ? 1.2 : 2,
                                                    '&:hover': {
                                                        bgcolor: alpha(theme.palette.secondary.main, 0.15),
                                                        transform: 'scale(1.1)'
                                                    },
                                                    '&:active': {
                                                        transform: 'scale(0.95)'
                                                    },
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: `0 2px 8px ${alpha(theme.palette.secondary.main, 0.15)}`,
                                                    border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`
                                                }}
                                            >
                                                <AddCircle 
                                                    sx={{ 
                                                        width: isMobile ? 28 : 40, 
                                                        height: isMobile ? 28 : 40,
                                                        color: theme.palette.secondary.main,
                                                        filter: `drop-shadow(0 2px 4px ${alpha(theme.palette.secondary.main, 0.4)})`
                                                    }} 
                                                />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 1,
                                                px: 1
                                            }}
                                        >
                                            <Typography 
                                                variant="caption" 
                                                color="text.secondary" 
                                                align="center"
                                                sx={{ 
                                                    fontWeight: 500,
                                                    opacity: 0.9,
                                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                                    lineHeight: 1.2,
                                                    minHeight: '2.4em',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {t("StartMaintenance")}
                                            </Typography>
                                            <Stack 
                                                direction="row" 
                                                spacing={1}
                                                sx={{
                                                    background: alpha(theme.palette.primary.main, 0.05),
                                                    borderRadius: 2,
                                                    p: 0.5,
                                                    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
                                                }}
                                            >
                                                <IconButton 
                                                    onClick={() => setQrOpen(true)}
                                                    sx={{ 
                                                        bgcolor: alpha(theme.palette.primary.main, 0.08),
                                                        p: isMobile ? 1 : 1.5,
                                                        '&:hover': {
                                                            bgcolor: alpha(theme.palette.primary.main, 0.15),
                                                            transform: 'scale(1.1)'
                                                        },
                                                        '&:active': {
                                                            transform: 'scale(0.95)'
                                                        },
                                                        transition: 'all 0.2s ease',
                                                        boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`,
                                                        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
                                                    }}
                                                >
                                                    <QrCode2Icon 
                                                        sx={{ 
                                                            width: isMobile ? 20 : 24,
                                                            height: isMobile ? 20 : 24,
                                                            color: theme.palette.primary.main,
                                                            filter: `drop-shadow(0 2px 4px ${alpha(theme.palette.primary.main, 0.4)})`
                                                        }} 
                                                    />
                                                </IconButton>
                                                <IconButton 
                                                    onClick={() => setBarcodeOpen(true)}
                                                    sx={{ 
                                                        bgcolor: alpha(theme.palette.primary.main, 0.08),
                                                        p: isMobile ? 1 : 1.5,
                                                        '&:hover': {
                                                            bgcolor: alpha(theme.palette.primary.main, 0.15),
                                                            transform: 'scale(1.1)'
                                                        },
                                                        '&:active': {
                                                            transform: 'scale(0.95)'
                                                        },
                                                        transition: 'all 0.2s ease',
                                                        boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`,
                                                        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
                                                    }}
                                                >
                                                    <CropFreeIcon 
                                                        sx={{ 
                                                            width: isMobile ? 20 : 24,
                                                            height: isMobile ? 20 : 24,
                                                            color: theme.palette.primary.main,
                                                            filter: `drop-shadow(0 2px 4px ${alpha(theme.palette.primary.main, 0.4)})`
                                                        }} 
                                                    />
                                                </IconButton>
                                            </Stack>
                                        </Box>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 1,
                                                px: 1
                                            }}
                                        >
                                            <Typography 
                                                variant="caption" 
                                                color="text.secondary" 
                                                align="center"
                                                sx={{ 
                                                    fontWeight: 500,
                                                    opacity: 0.9,
                                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                                    lineHeight: 1.2,
                                                    minHeight: '2.4em',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {t("OpenScheduledMaintenance")}
                                            </Typography>
                                            <IconButton 
                                                onClick={OpenPlannedMaintenancePage}
                                                sx={{ 
                                                    bgcolor: alpha(theme.palette.info.main, 0.08),
                                                    p: isMobile ? 1.2 : 2,
                                                    '&:hover': {
                                                        bgcolor: alpha(theme.palette.info.main, 0.15),
                                                        transform: 'scale(1.1)'
                                                    },
                                                    '&:active': {
                                                        transform: 'scale(0.95)'
                                                    },
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: `0 2px 8px ${alpha(theme.palette.info.main, 0.15)}`,
                                                    border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`
                                                }}
                                            >
                                                <AddBox 
                                                    sx={{ 
                                                        width: isMobile ? 28 : 40, 
                                                        height: isMobile ? 28 : 40,
                                                        color: theme.palette.info.main,
                                                        filter: `drop-shadow(0 2px 4px ${alpha(theme.palette.info.main, 0.4)})`
                                                    }} 
                                                />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* QR Scanner */}
                        <Fade in={qrOpen}>
                            <Card 
                                sx={{ 
                                    display: qrOpen ? 'block' : 'none',
                                    borderRadius: isMobile ? 3 : 1,
                                    overflow: 'hidden',
                                    boxShadow: isMobile ? theme.shadows[8] : theme.shadows[2]
                                }}
                            >
                                <CardContent sx={{ p: isMobile ? 1 : 2 }}>
                                    <div ref={qrRef}>
                                        <QrReader
                                            scanDelay={500}
                                            onResult={HandleScan}
                                            constraints={{ facingMode: "environment" }}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </CardContent>
                            </Card>
                        </Fade>

                        {/* Barcode Scanner */}
                        <Fade in={barcodeOpen}>
                            <Card 
                                sx={{ 
                                    display: barcodeOpen ? 'block' : 'none',
                                    borderRadius: isMobile ? 3 : 1,
                                    overflow: 'hidden'
                                }}
                            >
                                <CardContent sx={{ p: isMobile ? 2 : 3 }}>
                                    <TextField
                                        fullWidth
                                        autoFocus
                                        placeholder={t("ScanBarcode")}
                                        onChange={HandleScanBarcode}
                                        onKeyDown={handleKeypress}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: isMobile ? 2 : 1,
                                                '& fieldset': {
                                                    borderColor: alpha(theme.palette.primary.main, 0.2),
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: alpha(theme.palette.primary.main, 0.3),
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton 
                                                        edge="end" 
                                                        color="primary" 
                                                        onClick={handleSubmit}
                                                        sx={{
                                                            '&:hover': {
                                                                transform: 'scale(1.1)',
                                                            },
                                                            transition: 'transform 0.2s ease'
                                                        }}
                                                    >
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </Fade>
                    </Stack>

                    {/* Security Dialog */}
                    <Dialog 
                        open={securityDialogOpen}
                        onClose={() => setSecurityDialogOpen(false)}
                        PaperProps={{
                            sx: {
                                borderRadius: isMobile ? 3 : 2,
                                width: '90%',
                                maxWidth: 400,
                                overflow: 'hidden'
                            }
                        }}
                    >
                        <DialogTitle sx={{ 
                            py: isMobile ? 1.5 : 2,
                            px: isMobile ? 2 : 3,
                            bgcolor: 'primary.main',
                            color: 'primary.contrastText'
                        }}>
                            {t("WarningNotice")}
                        </DialogTitle>
                        <DialogContent sx={{ p: isMobile ? 2 : 3 }}>
                            <Typography variant="body1" sx={{ opacity: 0.9 }}>
                                {t("WarningMessage")}
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ px: isMobile ? 2 : 3, py: isMobile ? 1.5 : 2 }}>
                            <Button 
                                onClick={HandleSecurityDialogClose}
                                variant="contained"
                                sx={{ 
                                    borderRadius: isMobile ? 2 : 1,
                                    textTransform: 'none',
                                    px: 3
                                }}
                            >
                                {t("Confirm")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Container>
            )}
            <LoadingBackdrop />
        </Box>
    );
}
